
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_4719_4701)"}},[_c('path',{attrs:{"d":"M8.75 10.834H6.667v-2.5H8.75V6.25h2.5v2.084h2.084v2.5H11.25v2.083h-2.5v-2.083zM10 1.667l-6.667 2.5v5.075c0 4.208 2.842 8.133 6.667 9.092 3.825-.959 6.667-4.884 6.667-9.092V4.167L10 1.667z","fill":"currentColor"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_4719_4701"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h20v20H0z"}})])])])
          )
        }
      }
    